import React, { useState, useEffect, useLayoutEffect } from "react";
import { Table, Switch, Button, Tag, Tooltip, Input, message, Modal, DatePicker, Select, Descriptions, Flex } from "antd";
import { makeStyles } from "@mui/styles";
import { CheckCircleFilled, CheckOutlined, CloseOutlined, DeleteFilled, EditOutlined, PlusOutlined } from "@ant-design/icons";
import Message from "../../Components/common/Message";
import AuthService from "../../Components/auth/AuthService";
import moment from "moment";
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import { Pagination } from "@mui/material";
import { DATE_FORMAT, DEFAULT_DATE_FORMAT, InventoryStatuses, issuePriorities } from "../../Components/common/constants";
import { useNavigate } from "react-router-dom";

import dayjs from "dayjs";
import { Grid } from "@mui/material";
const Auth = new AuthService();

const useStyles = makeStyles((theme) => ({
  dataSheet: {
    padding: "5px",

  },
}));

const WorkOrderList = () => {
  const classes = useStyles();
  const { Option } = Select
  var layoutDispatch = useLoadingDispatch();
  const navigate = useNavigate();
  const [loadMessage, setLoadMessage] = useState("");
  const [type, setType] = useState("");
  const [allWorkOrders, setAllWorkOrders] = useState([]);
  const [page, setPage] = React.useState(1);
  const [pageChange, setPageChange] = React.useState(false);
  const [limit] = React.useState(50);
  const [totalPages, setTotalPages] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(null);

  const [vehicles, setVehicles] = useState([])

  const currentDate = new Date();
  const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const lastDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
  const [startDate, setStartDate] = useState(firstDayOfMonth);
  const [endDate, setEndDate] = useState(lastDayOfMonth);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const [selectedText, setSelectedText] = useState("");


  const getAllVehicles = async () => {
    showLoading(layoutDispatch);
    try {
      const response = await Auth.fetch(`/vehicle/vehicles`);
      if (response) {
        hideLoading(layoutDispatch);
        if (response?.ack) {
          setVehicles(response.vehicles);
        } else {
          setVehicles([])
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      hideLoading(layoutDispatch)
    }
  }

  useLayoutEffect(() => {
    getAllVehicles()
  }, [])


  const handleChange = (event, value) => {
    setPage(value);
    setPageChange(true)
  };

  const deleteWorkOrder = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/inventory/work-order`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        getAllWorkOrders();
        message.success(res?.message);
      } else {
        message.error(res?.message);
      }
    } catch (err) {
      console.log(err);
      message.error(err?.message);
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  const workOrderColumns = [
    {
      title: 'Status',
      render: (_, record) => {
        const { posted_by, due_date } = record;
        let statusText;
        let statusIcon;

        if (posted_by > 0) {
          statusText = 'Resolved';
          statusIcon = <CheckCircleFilled />;
        } else {
          const currentDate = new Date();
          const dueDate = new Date(due_date);

          if (dueDate < currentDate) {
            statusText = 'Overdue';
            statusIcon = <CloseOutlined />;
          } else {
            statusText = 'Open';
            statusIcon = <CheckOutlined />;
          }
        }

        return (
          <Tag icon={statusIcon} color={statusText === 'Resolved' ? 'blue' : statusText === 'Overdue' ? 'red' : 'green'}>
            {statusText}
          </Tag>
        );
      },
    },
    {
      title: 'Code',
      dataIndex: 'work_order_code',
      key: 'work_order_code',
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Reported Date',
      render: (record) => {
        return (
          <>
            <span>{record.work_order_date ? dayjs(record.work_order_date).format(`${DATE_FORMAT} HH:mm:ss`) : ''}</span>
          </>
        )
      }
    },
    {
      align: "center",
      title: "Vehicle",
      render: (record) => {
        const object = vehicles.find((obj) => obj.id === record?.vehicle_id);
        return (
          <span >
            {object?.registration_number ? object?.registration_number : ""}
          </span>
        );
      },
    },

    {
      title: 'Priority',
      render: (record) => {
        const object = issuePriorities?.find((obj) => obj.id === record?.priority);
        return (
          <Tag icon={object?.icon} color={object?.color}>
            {object?.title || ""}
          </Tag>
        );
      },
    },

    {
      title: 'Due Date',
      render: (record) => {
        return (
          <>
            <span>{record.due_date ? dayjs(record.due_date).format(`${DATE_FORMAT} HH:mm:ss`) : ''}</span>
          </>
        )
      }
    },
    {
      title: 'Completion Date',
      render: (record) => {
        return (
          <>
            <span>{record.completion_date ? dayjs(record.completion_date).format(DATE_FORMAT) : ''}</span>
          </>
        )
      }
    },

    {
      title: 'Action',
      key: 'action',
      align: 'right',
      render: (text, record) => (
        <Flex justify="end">
          {
            !record.posted_by > 0 && (
              <DeleteFilled style={
                {
                  fontSize: "25px",
                  cursor: "pointer",
                  color: "#cd1437",
                }} onClick={() => {
                  Modal.confirm({
                    title: 'Delete Work Order',
                    centered: true,
                    content: `Are you sure you want to delete this work order?`,
                    onOk: () => deleteWorkOrder(record.id),
                    okText: 'Delete',
                    cancelText: 'Cancel',
                    width: 600,
                    okButtonProps: { size: "large" },
                    cancelButtonProps: { size: "large" },
                  });
                }}
              />
            )
          }
          {
            record.status == 1 && (
              <EditOutlined
                style={{
                  fontSize: "25px",
                  cursor: "pointer",
                  marginRight: "5px",
                  color: "#006cb8",
                }} onClick={() => navigate(`/workshop_work_order/${record.id}`)} />
            )
          }




        </Flex>
      )
    },

  ];

  const getAllWorkOrders = async (download) => {
    let search = {};
    if (page && pageChange) search.page = page;
    if (startDate) search.start_date = moment(startDate).format("YYYY-MM-DD");
    if (endDate) search.end_date = moment(endDate).format("YYYY-MM-DD");
    if (selectedVehicle) search.vehicle_id = selectedVehicle;
    if (selectedStatus) search.status = selectedStatus;
    if (selectedText) search.searchText = selectedText;

    if (download) search.download = 1;

    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch("/inventory/work-orders", {
        method: "POST",
        body: JSON.stringify(search),
      });
      if (res?.ack) {
        if (download == 1) {
          window.open(res.file_url, "_blank", "noreferrer");
        } else {
          setAllWorkOrders(res?.work_orders);
          setTotalPages(Math.ceil(res?.total_count / limit));
          setTotalCount(res.total_count);
          // setSelectedText("")

        }
      } else {
        setAllWorkOrders([])
        message.error(res?.message)
      }
    } catch (err) {
      console.log(err);
      message.error(err?.message)
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  useEffect(() => {
    message.config({
      top: window.innerHeight - 100,
      duration: 3,
    });
  }, []);

  useEffect(() => {
    const timeOutId = setTimeout(() => getAllWorkOrders(), 100);
    return () => clearTimeout(timeOutId);
  }, [
    page,
    startDate,
    endDate,
    selectedVehicle,
    selectedStatus,
    // selectedText
  ]);

  const OnTitleSearch = () => {
    setPageChange(false)
    setPage(1)
    getAllWorkOrders()
  }


  const updateFilters = (newValues) => {
    const existingFiltersString = localStorage.getItem('workOrderFilters');
    const existingFilters = existingFiltersString ? JSON.parse(existingFiltersString) : {};

    Object.assign(existingFilters, newValues);

    existingFilters.timestamp = new Date().getTime();

    const updatedFiltersString = JSON.stringify(existingFilters);

    localStorage.setItem('workOrderFilters', updatedFiltersString);
  };

  const getFiltersOrDefault = () => {
    const existingFiltersString = localStorage.getItem('workOrderFilters');
    const existingFilters = existingFiltersString ? JSON.parse(existingFiltersString) : {};
    const currentTime = new Date().getTime();
    const expirationTime = 30 * 60 * 1000;


    if (existingFilters.timestamp && currentTime - existingFilters.timestamp < expirationTime) {


      if (!existingFilters.vehicle) {
        existingFilters.vehicle = null;
      }

      if (!existingFilters.status) {
        existingFilters.status = null;
      }

      return existingFilters;
    } else {
      localStorage.removeItem('workOrderFilters');
      return {};
    }
  };

  useEffect(() => {
    const initialState = getFiltersOrDefault();
    setSelectedVehicle(initialState?.vehicle);
    setSelectedStatus(initialState?.status);
    if (!initialState?.startDate) {
      const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      setStartDate(firstDayOfMonth);
      initialState.startDate = firstDayOfMonth

    } else {
      setStartDate(initialState.startDate);
    }

    if (!initialState?.endDate) {
      const lastDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
      setEndDate(lastDayOfMonth);
      initialState.endDate = lastDayOfMonth

    } else {
      setEndDate(initialState.endDate);
    }
    initialState.timestamp = new Date().getTime();
    updateFilters(initialState)

  }, []);

  return (
    <div className={classes.dataSheet}>
      <Flex justify="space-between" align="center">
        <h2 style={{ margin: 0 }}>Work Order List</h2>
        <Button onClick={() => navigate('/workshop_work_order/new')} type="primary" icon={<PlusOutlined />}>Add Work Order</Button>
      </Flex>

      <Grid container spacing={2}>
        {/* Start Date */}
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <label htmlFor="startDate">Start Due Date</label>
          <DatePicker
            format={DATE_FORMAT}
            style={{ width: "100%" }}
            size="large"
            value={startDate ? dayjs(startDate) : null}
            onChange={(date) => {
              const nativeDate = date ? date.toDate() : null;
              setStartDate(nativeDate);
              setPageChange(false);
              setPage(1);
              updateFilters({
                startDate: nativeDate
                  ? dayjs(nativeDate).format(DEFAULT_DATE_FORMAT)
                  : null,
              });
            }}
            placeholder="Select Date"
            allowClear={false}
          />
        </Grid>

        {/* End Date */}
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <label htmlFor="endDate">End Due Date</label>
          <DatePicker
            format={DATE_FORMAT}
            style={{ width: "100%" }}
            size="large"
            value={endDate ? dayjs(endDate) : null}
            onChange={(date) => {
              const nativeDate = date ? date.toDate() : null;
              setEndDate(nativeDate);
              setPageChange(false);
              setPage(1);
              updateFilters({
                endDate: nativeDate
                  ? dayjs(nativeDate).format(DEFAULT_DATE_FORMAT)
                  : null,
              });
            }}
            placeholder="Select Date"
            allowClear={false}
          />
        </Grid>

        {/* Vehicle */}
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <label htmlFor="vehicle">Vehicles</label>
          <Select
            style={{ width: "100%" }}
            showSearch
            allowClear
            size="large"
            value={selectedVehicle}
            placeholder="Vehicle"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => {
              setSelectedVehicle(value);
              setPageChange(false);
              setPage(1);
              updateFilters({ vehicle: value });
            }}
          >
            {vehicles.map((item) => (
              <Option key={item.id} value={item.id}>
                {item?.registration_number}
              </Option>
            ))}
          </Select>
        </Grid>

        {/* Status */}
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <label htmlFor="status">Status</label>
          <Select
            style={{ width: "100%" }}
            showSearch
            allowClear
            size="large"
            value={selectedStatus}
            placeholder="Status"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => {
              setSelectedStatus(value);
              setPageChange(false);
              setPage(1);
              updateFilters({ status: value });
            }}
          >
            {InventoryStatuses.map((item) => (
              <Option key={item.id} value={item.id}>
                {item?.title}
              </Option>
            ))}
          </Select>
        </Grid>

        {/* Search Input + Button */}
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <div style={{ display: "flex", gap: "8px", marginTop: "21px" }}>
            <Input
              placeholder="Search By Title"
              value={selectedText}
              onChange={(e) => {
                setSelectedText(e.target.value);
              }}
              size="large"
            />
            <Button
              type="primary"
              size="large"
              onClick={OnTitleSearch}
            >
              Search
            </Button>
          </div>
        </Grid>
      </Grid>
      <Table
        columns={workOrderColumns}
        style={{ marginTop: '10px' }}

        scroll={{ x: 'max-content' }}
        pagination={false}
        dataSource={allWorkOrders}
        footer={() => {
          const startRecord = (page - 1) * limit + 1;
          const endRecord = Math.min(page * limit, allWorkOrders?.length ? totalCount : 0);
          return `Showing ${startRecord}-${endRecord} of ${allWorkOrders?.length ? totalCount : "0"} Records`;
        }}
      />
      
      <div style={{ float: "right", margin: "10px" }}>
        <Pagination
          page={page}
          count={totalPages}
          variant="outlined"
          color="primary"
          onChange={handleChange}
        />
      </div>
      <Message type={type} msg={loadMessage} />
    </div>
  );
};

export default WorkOrderList;
